export default __webpack_public_path__ + "static/media/submit.89115b65.svg";